export const settings: Pickadate.DateOptions = {
  monthsFull: [ 'január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december' ],
  monthsShort: [ 'jan', 'febr', 'márc', 'ápr', 'máj', 'jún', 'júl', 'aug', 'szept', 'okt', 'nov', 'dec' ],
  weekdaysFull: [ 'vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat' ],
  weekdaysShort: [ 'V', 'H', 'K', 'SZe', 'CS', 'P', 'SZo' ],
  today: 'Ma',
  clear: 'Törlés',
  close: 'Bezárás',
  firstDay: 1,
  format: 'yyyy. mmmm dd.',
  formatSubmit: 'yyyy/mm/dd',
};
